import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import CreateYourOwn from "../components/CreateYourOwn";
import EmailGate from "../components/EmailGate";
import RecentBuddiesMarquee from "../components/RecentBuddiesMarquee";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useEffect } from "react";
import useSeo from "../lib/useSeo";

export default function CreateBuddy() {
  useSeo({
    title: "Create your custom Plate Buddy — kid-friendly food character generator",
    description:
      "Design a one-of-a-kind Plate Buddy in your child's name. Illustrated in seconds, paired with a coordinated kid-friendly recipe. Ages 2–7.",
    url: "https://platebuddies.com/create",
  });
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid="page-create-buddy" className="font-body bg-pb-cream min-h-screen">
      <Navbar />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-8">
        <Link
          to="/home"
          data-testid="link-back-home"
          className="inline-flex items-center gap-2 text-sm font-bold text-pb-soft hover:text-pb-coral transition"
        >
          <ArrowLeft className="h-4 w-4" /> Back home
        </Link>
      </div>
      <EmailGate
        feature="generator"
        title="Unlock the Buddy Generator"
        blurb="Design a one-of-a-kind Plate Buddy in your child's name — illustrated in seconds and paired with a coordinated kid-friendly recipe."
        source="create_buddy"
      >
        <CreateYourOwn />
      </EmailGate>
      <RecentBuddiesMarquee
        theme="cream"
        limit={24}
        headline="Made by other families this week"
        subline="Need inspiration? Here are the most recent Buddies dreamed up by other kids."
      />
      <Footer />
    </div>
  );
}
